import * as React from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { api } from "../api";

export const RandomEntryPage = (): JSX.Element => {
  const history = useHistory();

  useEffect(() => {
    const loadRandom = async () => {
      const result = await api.get<"/api/random">("/api/random");

      if (result.entry_id === null) {
        return;
      }

      history.push(`/entry/${result.entry_id}`);
    };

    loadRandom();
  }, [history]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-lg text-slate-600 dark:text-white/70">
        Loading random entry...
      </div>
    </div>
  );
};
